import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TechfinanceService } from 'src/app/services/techfinance.service';

@Component({
  selector: 'app-informations',
  templateUrl: './informations.component.html',
  styleUrls: ['./informations.component.scss'],
})
export class InformationsComponent implements OnInit {
  clientsData: any;
  studyForm: FormGroup;
  study: any = {}
  deleteConfirmation: boolean = false;
  closeConfirmation: boolean = false;

  constructor(
    private fb: FormBuilder,
    public studiesService: TechfinanceService,
    public dialogRef: MatDialogRef<InformationsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { study: any }
  ) {}

  ngOnInit(): void {
   
    this.studyForm = this.fb.group({
      name: ['', Validators.required],
    });
    this.study = this.data.study
  }

  deleteScreenCall(screenCall: boolean): void {
    this.deleteConfirmation = screenCall;
  }

  onSubmit() {
    if (this.studyForm.valid) {
      const updatedStudyData = {
        ...this.study,
        name: this.studyForm.get('name')?.value,
        updatedAt: new Date().toISOString(),
      };
      this.studiesService
        .updateGuiaStudies(this.study._id, updatedStudyData)
        .subscribe(
          (res) => {
            this.dialogRef.close({ updated: true, study: updatedStudyData });
          },
          (error) => {
            console.error('Erro ao atualizar o estudo:', error);
          }
        );
    }
  }

  onDeleteStudy() {
    if (this.study._id) {
      this.studiesService
        .deleteGuiaStudies(this.study._id)
        .subscribe((res) => {
          this.dialogRef.close({
            deleted: true,
            studyId: this.study._id,
          });
        });
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
